import React from 'react';
import { REACT_APP_DOCS_URL } from '../../constants/config';
import logo from '../../logo/logo.png';
import UnifiedFooter from './UnifiedFooter';

const Footer = () => {
  const docsUrl = REACT_APP_DOCS_URL;
  const mainUrl = process.env.REACT_APP_MAIN_SITE_URL || '';

  return (
    <UnifiedFooter
      mainUrl={mainUrl}
      docsUrl={docsUrl}
      logo={<img src={logo} alt="Sophare AI Logo" className="w-6 h-6 mr-2" />}
    />
  );
};

export default Footer;
